/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import omit from 'lodash/omit';

class RedactorTextArea extends React.Component {
  constructor(props) {
    super(props);

    this.handleBlur = this.handleBlur.bind(this);
    this.processData = this.processData.bind(this);
  }

  componentDidMount() {
    const node = ReactDOM.findDOMNode(this);
    $R(node, this.props.options);
  }

  componentWillUnmount() {
    const node = ReactDOM.findDOMNode(this);
    $R(node, 'destroy');
  }

  handleBlur(value) {
    const artificialEvent = {
      target: { value }
    };

    this.props.onBlur(artificialEvent);
  }

  processData(callback) {
    const node = ReactDOM.findDOMNode(this);
    const content = $R(node, 'source.getCode');

    if(callback && typeof callback === 'function') {
      return callback(content);
    }
    return content;
  }

  render() {
    const passThruProps = omit(this.props, 'options');

    return (
      <textarea {...passThruProps} />
    );
  }
}

RedactorTextArea.propTypes = {
  onBlur: PropTypes.func.isRequired,
  options: PropTypes.object
};

RedactorTextArea.defaultProps = {
  options: {}
};

export default RedactorTextArea;
